// import React, { useState, useEffect, useRef } from 'react';
// import { GoogleMap, LoadScript, OverlayView, Marker } from '@react-google-maps/api';
// import { UserLocationIndicater } from '../assets/constants/Icons';
// import { useLocation } from "react-router-dom";
// import LockerIcon from '../assets/locker.svg';
// import { applyBackendLanguageConfig, calculateDistanceMap, checkIfAssignmentIsProperlyConfigured, extractDomain, getSSize24HrPrice, setDomainAndLockerBankIdInLocalStorage, sortByDistance } from '../lib/Utils';
// import { AdvanceBookingLockerBankDetails, getDomainAndLockerBankIdFromShortCode, getTenantAndAssignmentSettings } from '../api/api';
// import {useHistory} from 'react-router-dom';
// import { IS_LOGGED_IN, LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK } from '../assets/constants/BrowserStorageKeys';
// import { SUCCESS } from '../assets/constants/Constants';
// import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
// import { t } from 'i18next';
// import CircularProgressLoader from './CircularProgressLoader';
// import SearchSection from './SearchSectionComponent';
// import LocationSlider from './LocationSliderComponent';

// // Default fallback data
// const defaultLocationData = [
//   {
//     id: 1,
//     name: 'Pune City',
//     marathiName: 'पुणे शहर',
//     position: { lat: 18.5204, lng: 73.8567 },
//     type: 'city',
//     description: 'Cultural capital of Maharashtra, IT hub',
//     address: 'MG Road, Pune Camp Area',
//     lockerNumber: 'PN-001',
//     distance: '0',
//     available: 25,
//     price: '₹35/hr',
//     city: 'Pune',
//     state: 'Maharashtra',
//     logoImage: null,
//     status: 'published'
//   }
// ];

// // Transform API data to component format
// const transformAPIData = (apiData) => {
//   if (!apiData || !Array.isArray(apiData)) return [];
  
//   return apiData.map((item, index) => {
//     const buildAddress = () => {
//       const parts = [
//         item.address_line1,
//         item.address_line2,
//         item.city,
//         item.state,
//         item.pincode
//       ].filter(Boolean);
//       return parts.length > 0 ? parts.join(', ') : 'Address not available';
//     };

//     const lockerNumber = `${String(item.id || index + 1).padStart(3, '0')}`;

//     return {
//       id: item.id || index + 1,
//       name: item.name || item.location || 'Unknown Location',
//       district: item.city || 'Unknown distic',
//       position: { 
//         lat: item.latitude ? parseFloat(item.latitude) : 18.5204,
//         lng: item.longitude ? parseFloat(item.longitude) : 73.8567
//       },
//       type: item.category?.name?.toLowerCase() || 'city',
//       description: item.description || item.location || 'no data',
//       address: buildAddress(),
//       lockerNumber: lockerNumber,
//       available: item.available || (item.status === 'published' ? 10 : 5),
//       price: getSSize24HrPrice(item.pricing) || 'no data',
//       city: item.city || 'no data',
//       state: item.state || 'no data',
//       status: item.status || 'no data',
//       logoImage: item.logo_image || null,
//       backgroundImage: item.background_image || null,
//       code : item.code
//     };
//   });
// };



// const LockerMapMobile = ({ isPreview = false, initialLocation = null }) => {
//   const location = useLocation();
//   const [dataLoaded, setDataLoaded] = useState(false);
  
//   const { center, useUserLocation, lockersData: passedData, timestamp } = location.state || {};
  
//   console.log("Map component received raw data:", passedData);

//   const [validData, setValidData] = useState([]);
//   const history = useHistory();
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [zoom, setZoom] = useState(15);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [filteredLocations, setFilteredLocations] = useState([]);
//   const [showInfoPanel, setShowInfoPanel] = useState(false);
//   const [isSliderVisible, setIsSliderVisible] = useState(true);
//   const [dragStartY, setDragStartY] = useState(0);
//   const [isDragging, setIsDragging] = useState(false);
//   const [sliderHeight, setSliderHeight] = useState(35);
  
//   const [currentLocation, setCurrentLocation] = useState(center || null);
//   const [locationError, setLocationError] = useState(null);
//   const [isLocating, setIsLocating] = useState(false);
  
//   const sliderRef = useRef(null);
//   const containerRef = useRef(null);
//   const mapRef = useRef(null);
//   const [mapCenter, setMapCenter] = useState(
//     center || initialLocation || { lat: 18.5204, lng: 73.8567 }
//   );
// const [ isLoading, setIsLoading] = useState(false);
// const [loadingMessage, SetLoadingMessage] = useState("Please wait..")

// const [searchSuggestions, setSearchSuggestions] = useState([]);
// const [showSuggestions, setShowSuggestions] = useState(false);
// const [highlightedIndex, setHighlightedIndex] = useState(-1);
// const searchInputRef = useRef(null);
// const suggestionsRef = useRef(null);

// // Add this function to generate search suggestions
// const generateSearchSuggestions = (query) => {
//   if (!query.trim()) return [];
  
//   const searchTerm = query.toLowerCase().trim();
//   const suggestions = [];
//   const seen = new Set(); // To avoid duplicates
  
//   // Search through validData for matches
//   validData.forEach(loc => {
//     // Check different fields for matches
//     const nameMatch = loc.name?.toLowerCase().includes(searchTerm);
//     const marathiNameMatch = loc.marathiName?.toLowerCase().includes(searchTerm);
//     const cityMatch = loc.city?.toLowerCase().includes(searchTerm);
//     const areaMatch = loc.area?.toLowerCase().includes(searchTerm);
//     const lockerNumberMatch = loc.lockerNumber?.toLowerCase().includes(searchTerm);
//     const descriptionMatch = loc.description?.toLowerCase().includes(searchTerm);
    
//     if (nameMatch && !seen.has(loc.name)) {
//       suggestions.push({
//         id: loc.id,
//         text: loc.name,
//         type: 'name',
//         location: loc
//       });
//       seen.add(loc.name);
//     }
    
//     if (marathiNameMatch && !seen.has(loc.marathiName)) {
//       suggestions.push({
//         id: `${loc.id}_marathi`,
//         text: loc.marathiName,
//         type: 'marathi_name',
//         location: loc
//       });
//       seen.add(loc.marathiName);
//     }
    
//     if (cityMatch && !seen.has(loc.city)) {
//       suggestions.push({
//         id: `${loc.id}_city`,
//         text: `${loc.city} (City)`,
//         type: 'city',
//         location: loc
//       });
//       seen.add(loc.city);
//     }
    
//     if (areaMatch && !seen.has(loc.area)) {
//       suggestions.push({
//         id: `${loc.id}_area`,
//         text: `${loc.area} (Area)`,
//         type: 'area',
//         location: loc
//       });
//       seen.add(loc.area);
//     }
    
//     if (lockerNumberMatch && !seen.has(loc.lockerNumber)) {
//       suggestions.push({
//         id: `${loc.id}_locker`,
//         text: `Locker #${loc.lockerNumber}`,
//         type: 'locker_number',
//         location: loc
//       });
//       seen.add(loc.lockerNumber);
//     }
//   });
  
//   // Add location-based suggestions if geolocation is available
//   if (currentLocation && suggestions.length === 0) {
//     suggestions.push({
//       id: 'current_location',
//       text: 'Use my current location',
//       type: 'current_location',
//       location: null
//     });
//   }
  
//   return suggestions.slice(0, 8); // Limit to 8 suggestions
// };

// // Handle search input change with suggestions
// const handleSearchChange = (e) => {
//   const value = e.target.value;
//   setSearchQuery(value);
  
//   if (value.trim()) {
//     const suggestions = generateSearchSuggestions(value);
//     setSearchSuggestions(suggestions);
//     setShowSuggestions(true);
//     setHighlightedIndex(-1);
//   } else {
//     setShowSuggestions(false);
//     setSearchSuggestions([]);
//   }
// };

// // Handle suggestion selection
// const handleSuggestionClick = (suggestion) => {
//   if (suggestion.type === 'current_location') {
//     getCurrentLocation();
//   } else if (suggestion.location) {
//     // Update search query with the selected text
//     setSearchQuery(suggestion.text);
//     // Center map on the selected location
//     setMapCenter(suggestion.location.position);
//     setZoom(16);
//     // Select the location
//     setSelectedLocation(suggestion.location);
//     setShowInfoPanel(true);
//     // Filter locations based on the search
//     const filtered = validData.filter(loc => 
//       loc.name === suggestion.location.name || 
//       loc.city === suggestion.location.city ||
//       loc.id === suggestion.location.id
//     );
//     setFilteredLocations(filtered);
//   }
  
//   setShowSuggestions(false);
//   setSearchSuggestions([]);
// };

// // Handle keyboard navigation
// const handleKeyDown = (e) => {
//   if (!showSuggestions) return;
  
//   switch (e.key) {
//     case 'ArrowDown':
//       e.preventDefault();
//       setHighlightedIndex(prev => 
//         prev < searchSuggestions.length - 1 ? prev + 1 : prev
//       );
//       break;
//     case 'ArrowUp':
//       e.preventDefault();
//       setHighlightedIndex(prev => prev > 0 ? prev - 1 : -1);
//       break;
//     case 'Enter':
//       e.preventDefault();
//       if (highlightedIndex >= 0 && searchSuggestions[highlightedIndex]) {
//         handleSuggestionClick(searchSuggestions[highlightedIndex]);
//       }
//       break;
//     case 'Escape':
//       setShowSuggestions(false);
//       break;
//   }
// };

// // Close suggestions when clicking outside
// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (searchInputRef.current && !searchInputRef.current.contains(event.target) &&
//         suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
//       setShowSuggestions(false);
//     }
//   };
  
//   document.addEventListener('mousedown', handleClickOutside);
//   return () => document.removeEventListener('mousedown', handleClickOutside);
// }, []);


//   // Process data when component mounts or when passedData changes
//   useEffect(() => {
//     console.log("Processing data...");
    
//     let processedData;
//     if (passedData && passedData.length > 0) {
//       processedData = transformAPIData(passedData);
//       console.log("Using API data (transformed):", processedData);
//     } else {
//       processedData = defaultLocationData;
//       console.log("Using default data");
//     }
    
//     const valid = processedData.filter(item => 
//       item && 
//       item.position && 
//       typeof item.position.lat === 'number' && 
//       typeof item.position.lng === 'number' &&
//       !isNaN(item.position.lat) && 
//       !isNaN(item.position.lng)
//     );
    
//     console.log("Valid data:", valid);
//     setValidData(valid);
//     setFilteredLocations(valid);
    
//     if (valid.length > 0 && !selectedLocation) {
//       setSelectedLocation(valid[0]);
//     }
    
//     setDataLoaded(true);
//   }, [passedData, timestamp]);

//   // Update map center when center changes
//   useEffect(() => {
//     if (center) {
//       setMapCenter(center);
//       setCurrentLocation(center);
//     }
//   }, [center]);

//   // Update distances when current location changes - USING UTILITY FUNCTIONS
//   useEffect(() => {
//     if (currentLocation && validData.length > 0) {
//       console.log('Current location changed, updating distances');
      
//       // Update distances using the utility function
//       const updatedLocations = validData.map(loc => ({
//         ...loc,
//         distance: calculateDistanceMap(currentLocation, loc.position)
//       }));
      
//       // Sort using the utility function
//       const sortedLocations = sortByDistance(updatedLocations, currentLocation);
      
//       console.log("Updated locations with distances:", sortedLocations);
      
//       // Update states
//       setFilteredLocations([...sortedLocations]);
//       setValidData([...sortedLocations]);
      
//       // Update selected location if it exists
//       if (selectedLocation) {
//         const updatedSelected = sortedLocations.find(l => l.id === selectedLocation.id);
//         if (updatedSelected) {
//           setSelectedLocation(updatedSelected);
//         }
//       }
//     }
//   }, [currentLocation?.lat, currentLocation?.lng, validData.length]); // Use specific dependencies

//   // Filter locations based on search
//   useEffect(() => {
//     if (!validData.length) return;
    
//     if (searchQuery.trim() === '') {
//       setFilteredLocations(validData);
//     } else {
//       const filtered = validData.filter(loc => 
//         loc.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         (loc.marathiName && loc.marathiName.toLowerCase().includes(searchQuery.toLowerCase())) ||
//         loc.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         loc.lockerNumber?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         loc.city?.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//       setFilteredLocations(filtered);
//     }
//   }, [searchQuery, validData]);

//   // Scroll to selected location in slider
//   useEffect(() => {
//     if (selectedLocation && sliderRef.current && isSliderVisible) {
//       const index = filteredLocations.findIndex(l => l.id === selectedLocation.id);
//       if (index !== -1) {
//         const cardWidth = 296;
//         sliderRef.current.scrollTo({
//           left: index * cardWidth,
//           behavior: 'smooth'
//         });
//       }
//     }
//   }, [selectedLocation, filteredLocations, isSliderVisible]);

//   const getCurrentLocation = () => {
//     setIsLocating(true);
//     setLocationError(null);
    
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const userLocation = {
//             lat: position.coords.latitude,
//             lng: position.coords.longitude
//           };
//           console.log('Got user location:', userLocation);
//           setCurrentLocation(userLocation);
//           setMapCenter(userLocation);
//           setZoom(16);
//           setIsLocating(false);
//         },
//         (error) => {
//           console.error('Error getting location:', error);
//           setLocationError('Unable to get your location');
//           setIsLocating(false);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 5000,
//           maximumAge: 0
//         }
//       );
//     } else {
//       setLocationError('Geolocation not supported');
//       setIsLocating(false);
//     }
//   };

//   const mapStyles = [
//     { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
//     { featureType: "poi.business", stylers: [{ visibility: "off" }] },
//     { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] },
//     { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] }
//   ];

//   const mapOptions = {
//     mapTypeId: 'roadmap',
//     mapTypeControl: false,
//     streetViewControl: false,
//     fullscreenControl: false,
//     zoomControl: true,
//     zoomControlOptions: { position: 9 },
//     gestureHandling: 'greedy',
//     disableDefaultUI: true,
//     styles: mapStyles,
//   };

//   const handleMapMarkerClick = (location) => {
//     if (!location || !location.position) return;
//     setSelectedLocation(location);
//     setMapCenter(location.position);
//     setZoom(17);
//     setShowInfoPanel(true);
//     setIsSliderVisible(true);
//     setSliderHeight(35);
//   };

// const getSettingsValidateAndRedirectUser = async (lockerBankId, location) => {
//   try {
//     const response = await getTenantAndAssignmentSettings(lockerBankId);
//     console.log("getTenantAndAssignmentSettings is :", response);
//     if (!response || response.status !== SUCCESS) {
//       console.error("Invalid response from API");
//       return;
//     }

//     // appying the style for application with language
//     applyBackendLanguageConfig(response);
//     const assignments = response?.data?.locker_assignments || [];

//     console.log("status:", response.status);
//     console.log("assignments:", assignments.length);
//     //  Case 1: Multiple assignments
//     if (assignments.length > 1) {
//       setIsLoading(false);
//       history.push({
//         pathname: "/assignments",
//         state: {
//           tenantAndAssignmentSettings: response.data
//         }
//       });
//       return;
//     }

//     //  Case 2: Single assignment
//     if (assignments.length === 1) {
//       const isAssignmentProperlyConfigured = await checkIfAssignmentIsProperlyConfigured(response.data);
//       if (isAssignmentProperlyConfigured === true) {
//         setIsLoading(false);
//         history.push({
//           pathname: "/locker-details",
//           state: {
//             lockerDetails: location
//           }
//         });
//       } else {
//         setIsLoading(false);
//         console.error("Assignment not properly configured:", isAssignmentProperlyConfigured);
//       }
//       return;
//     }

//     //  Case 3: No assignments
//     console.error("No locker assignments found");
//   } catch (error) {
//     setIsLoading(false);
//     console.error("Error while getting settings and validation:", error);
//   }
// };

// const handleSliderItemClick = async (location) => {
//   setIsLoading(true);
//   SetLoadingMessage("please wait");
//   console.log("selected locker is:", location);

//   if (location?.code) {
//     try {
//       const responseJson = await getDomainAndLockerBankIdFromShortCode(location.code);
//       if (responseJson.status === SUCCESS) {
//         const lockerBankId = responseJson?.data?.locker_bank_id || null;
//         const domain = extractDomain(responseJson?.data?.domain);
//         const domainAndLockerBankInfoObject = {
//           domain,
//           lockerBankId
//         };
//         setDomainAndLockerBankIdInLocalStorage(domainAndLockerBankInfoObject);
//         if (lockerBankId) {
//           await getSettingsValidateAndRedirectUser(lockerBankId, location);
//         }else{
//           setIsLoading(false);
//           console.error("locker bank id is not there please contact to admin");
//         }
//       }
//     } catch (error) {
//       setIsLoading(false);
//       console.error("HomePage.js - handleSliderItemClick", error);
//     }
//   }else{
//     setIsLoading(false);
//     console.error("not able to set the assignment details please due to locker code");
//   }
// };

//   const scrollSlider = (direction) => {
//     if (sliderRef.current) {
//       const scrollAmount = 296;
//       const newScrollLeft = sliderRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
//       sliderRef.current.scrollTo({
//         left: newScrollLeft,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const handleDragStart = (e) => {
//     e.preventDefault();
//     setDragStartY(e.touches ? e.touches[0].clientY : e.clientY);
//     setIsDragging(true);
//   };

//   const handleDragMove = (e) => {
//     if (!isDragging) return;
    
//     e.preventDefault();
//     const currentY = e.touches ? e.touches[0].clientY : e.clientY;
//     const deltaY = currentY - dragStartY;
    
//     if (isSliderVisible) {
//       const newHeight = Math.max(10, Math.min(35, sliderHeight - (deltaY / 10)));
//       setSliderHeight(newHeight);
      
//       if (newHeight < 12) {
//         setIsSliderVisible(false);
//       }
//     } else {
//       if (deltaY < -20) {
//         setIsSliderVisible(true);
//         setSliderHeight(35);
//       }
//     }
//   };

//   const handleDragEnd = () => {
//     setIsDragging(false);
    
//     if (isSliderVisible && sliderHeight < 12) {
//       setIsSliderVisible(false);
//     }
    
//     if (isSliderVisible) {
//       if (sliderHeight < 20) {
//         setSliderHeight(15);
//       } else if (sliderHeight > 35) {
//         setSliderHeight(35);
//       }
//     }
//   };

//   const LockerMarker = ({ location, onClick, isSelected }) => {
//     if (!location || !location.position) return null;
    
//     const getSizeClass = () => {
//       if (zoom >= 16) return 'xl';
//       if (zoom >= 14) return 'lg';
//       if (zoom >= 12) return 'md';
//       if (zoom >= 10) return 'sm';
//       return 'xs';
//     };

//     const sizeClass = getSizeClass();
    
//     const getColorClass = (type) => {
//       const colorMap = {
//         'city': 'city',
//         'industrial': 'industrial',
//         'commercial': 'commercial',
//         'municipal': 'municipal',
//         'temple': 'temple',
//         'tourist': 'tourist',
//         'landmark': 'landmark',
//         'area': 'area',
//         'society': 'society',
//         'store': 'store',
//         'colony': 'colony',
//         'market': 'market',
//         'park': 'park'
//       };
//       return colorMap[type?.toLowerCase()] || 'default';
//     };

//     return (
//       <OverlayView
//         position={location.position}
//         mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
//       >
//         <div 
//           className={`marker-container ${isSelected ? 'selected' : ''}`}
//           onClick={() => onClick(location)}
//         >
//           <div className={`marker-image-wrapper size-${sizeClass}`}>
//             <img 
//               src={LockerIcon}
//               alt={location.name}
//               className="marker-image"
//             />
//             <div className={`marker-badge badge-${sizeClass} marker-badge-${getColorClass(location.type)}`}>
//               {location.lockerNumber?.split('-')[1] || location.id}
//             </div>
//           </div>
//           <div className={`marker-label label-${sizeClass}`}>
//             {location.distance || '0'}km
//           </div>
//         </div>
//       </OverlayView>
//     );
//   };

//   const CurrentLocationMarker = () => {
//     const [mapsLoaded, setMapsLoaded] = useState(false);

//     useEffect(() => {
//       const checkMapsLoaded = () => {
//         if (window.google && window.google.maps) {
//           setMapsLoaded(true);
//         }
//       };

//       checkMapsLoaded();
//       const timer = setTimeout(checkMapsLoaded, 1000);
//       return () => clearTimeout(timer);
//     }, []);

//     if (!currentLocation || !currentLocation.lat || !currentLocation.lng || !mapsLoaded) {
//       return null;
//     }

//     return (
//       <Marker
//         position={currentLocation}
//         icon={{
//           path: window.google.maps.SymbolPath.CIRCLE,
//           scale: 10,
//           fillColor: "#4285F4",
//           fillOpacity: 1,
//           strokeColor: "white",
//           strokeWeight: 3,
//         }}
//         title="You are here"
//       />
//     );
//   };

//   // if (!dataLoaded || filteredLocations.length === 0) {
//   //   return (
//   //     <div className="map-mobile-container">
//   //       <div className="map-wrapper">
//   //         <div className="loading-container">
//   //           <div className="loading-content">
//   //             <div className="loading-text">Loading locations...</div>
//   //           </div>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );
//   // }

//   const HandlerForSelectedLocker = ()=>{
//     setShowInfoPanel(false);
//   }

//   const handleLockerNextPage = ()=>{
//   console.log("handleLockerNextPage clicked")

//   }


//   return (
//     <>
//     <div 
//       className="map-mobile-container"
//       onTouchMove={handleDragMove}
//       onTouchEnd={handleDragEnd}
//       onMouseMove={isDragging ? handleDragMove : null}
//       onMouseUp={handleDragEnd}
//       onMouseLeave={handleDragEnd}
//       ref={containerRef}
//     >
//               <div className="map-wrapper">
//                  {/* SEARCH SECTION */}
//                 <SearchSection
//                     searchQuery={searchQuery}
//                     onSearchChange={setSearchQuery}
//                     onSearchClear={() => {
//                       setFilteredLocations(validData);
//                     }}
//                     onSuggestionSelect={(suggestion) => {
//                       if (suggestion.type === 'current_location') {
//                         getCurrentLocation();
//                       } else if (suggestion.location) {
//                         setMapCenter(suggestion.location.position);
//                         setZoom(16);
//                         setSelectedLocation(suggestion.location);
//                         setShowInfoPanel(true);
//                       }
//                     }}
//                     validData={validData}
//                     currentLocation={currentLocation}
//                     filteredLocations={filteredLocations}
//                     setFilteredLocations={setFilteredLocations}
//                 />
//                 {locationError && (
//                   <div className="location-error">
//                     {locationError}
//                   </div>
//                 )}
//                   <LoadScript 
//                     googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
//                     loadingElement={
//                       <div className="loading-container">
//                         <div className="loading-content">
//                           <div className="loading-text">Loading Map...</div>
//                         </div>
//                       </div>
//                     }
//                   >
//                       <GoogleMap
//                         mapContainerStyle={{ width: '100%', height: '100%' }}
//                         center={mapCenter}
//                         zoom={zoom}
//                         options={mapOptions}
//                         onClick={() => setShowInfoPanel(false)}
//                         onLoad={(map) => {
//                           mapRef.current = map;
//                         }}
//                         onZoomChanged={() => {
//                           if (mapRef.current) {
//                             setZoom(mapRef.current.getZoom());
//                           }
//                         }}
//                       >
//                         <CurrentLocationMarker />
                        
//                         {filteredLocations.map((location) => (
//                           <LockerMarker
//                             key={location.id}
//                             location={location}
//                             onClick={handleMapMarkerClick}
//                             isSelected={selectedLocation?.id === location.id}
//                           />
//                         ))}
//                       </GoogleMap>
//                 </LoadScript>
                
//                 // In LockerMapMobile.jsx - Replace the bottom slider section:

// <div 
//   className={`bottom-slider-container ${!isSliderVisible ? 'hidden' : ''}`}
// >
//   <div 
//     className="drag-handle"
//     onTouchStart={handleDragStart}
//     onMouseDown={handleDragStart}
//   >
//     <div className="drag-handle-bar"></div>
//     <div className="drag-instruction">
//       {isSliderVisible 
//         ? sliderHeight >= 35
//           ? '↓ Drag down to hide' 
//           : '↓ Drag down to hide | ↑ Drag up to expand'
//         : '↑ Drag up to show lockers'}
//     </div>
//   </div>
  
//   {/* Use the LocationSlider component here */}
//   <LocationSlider
//     ref={sliderRef}
//     currentLocation={currentLocation}
//     filteredLocations={filteredLocations}
//     selectedLocation={selectedLocation}
//     onLocationClick={handleSliderItemClick}
//     onScrollLeft={() => scrollSlider('left')}
//     onScrollRight={() => scrollSlider('right')}
//     isVisible={isSliderVisible}
//   />
// </div>
        
//          {isLoading ? 
//             <CircularProgressLoader message={loadingMessage} /> : ''}
//       </div>
//     </div>
//     </>
//   );
// };

// export default LockerMapMobile;


import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, LoadScript, OverlayView, Marker } from '@react-google-maps/api';
import { UserLocationIndicater } from '../assets/constants/Icons';
import { useLocation } from "react-router-dom";
import LockerIcon from '../assets/locker.svg';
import { applyBackendLanguageConfig, calculateDistanceMap, checkIfAssignmentIsProperlyConfigured, extractDomain, getSSize24HrPrice, setDomainAndLockerBankIdInLocalStorage, sortByDistance } from '../lib/Utils';
import { AdvanceBookingLockerBankDetails, getDomainAndLockerBankIdFromShortCode, getTenantAndAssignmentSettings } from '../api/api';
import {useHistory} from 'react-router-dom';
import { IS_LOGGED_IN, LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK } from '../assets/constants/BrowserStorageKeys';
import { SUCCESS } from '../assets/constants/Constants';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { t } from 'i18next';
import CircularProgressLoader from './CircularProgressLoader';
import SearchSection from './SearchSectionComponent';
import LocationSlider from './LocationSliderComponent';

// Remove defaultLocationData - no longer needed

// Transform API data to component format
const transformAPIData = (apiData) => {
  if (!apiData || !Array.isArray(apiData)) return [];
  
  return apiData.map((item, index) => {
    const buildAddress = () => {
      const parts = [
        item.address_line1,
        item.address_line2,
        item.city,
        item.state,
        item.pincode
      ].filter(Boolean);
      return parts.length > 0 ? parts.join(', ') : 'Address not available';
    };

    const lockerNumber = `${String(item.id || index + 1).padStart(3, '0')}`;

    return {
      id: item.id || index + 1,
      name: item.name || item.location || 'Unknown Location',
      district: item.city || 'Unknown distic',
      position: { 
        lat: item.latitude ? parseFloat(item.latitude) : 18.5204,
        lng: item.longitude ? parseFloat(item.longitude) : 73.8567
      },
      type: item.category?.name?.toLowerCase() || 'city',
      description: item.description || item.location || 'no data',
      address: buildAddress(),
      lockerNumber: lockerNumber,
      available: item.available || (item.status === 'published' ? 10 : 5),
      price: getSSize24HrPrice(item.pricing) || 'no data',
      city: item.city || 'no data',
      state: item.state || 'no data',
      status: item.status || 'no data',
      logoImage: item.logo_image || null,
      backgroundImage: item.background_image || null,
      code : item.code
    };
  });
};


const LockerMapMobile = ({ isPreview = false, initialLocation = null }) => {
  const location = useLocation();
  const [dataLoaded, setDataLoaded] = useState(false);
  
  const { center, useUserLocation, lockersData: passedData, timestamp } = location.state || {};
  
  console.log("Map component received raw data:", passedData);

  const [validData, setValidData] = useState([]);
  const history = useHistory();
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [zoom, setZoom] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [showInfoPanel, setShowInfoPanel] = useState(false);
  const [isSliderVisible, setIsSliderVisible] = useState(true);
  const [dragStartY, setDragStartY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [sliderHeight, setSliderHeight] = useState(35);
  
  const [currentLocation, setCurrentLocation] = useState(center || null);
  const [locationError, setLocationError] = useState(null);
  const [isLocating, setIsLocating] = useState(false);
  
  const sliderRef = useRef(null);
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const [mapCenter, setMapCenter] = useState(
    center || initialLocation || { lat: 18.5204, lng: 73.8567 }
  );
  const [ isLoading, setIsLoading] = useState(false);
  const [loadingMessage, SetLoadingMessage] = useState("Please wait..")

  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const searchInputRef = useRef(null);
  const suggestionsRef = useRef(null);
  const [cachedData, setCachedData] = useState(null);

  // Add this function to generate search suggestions
  const generateSearchSuggestions = (query) => {
    if (!query.trim()) return [];
    
    const searchTerm = query.toLowerCase().trim();
    const suggestions = [];
    const seen = new Set();
    
    // Search through validData for matches
    validData.forEach(loc => {
      const nameMatch = loc.name?.toLowerCase().includes(searchTerm);
      const marathiNameMatch = loc.marathiName?.toLowerCase().includes(searchTerm);
      const cityMatch = loc.city?.toLowerCase().includes(searchTerm);
      const areaMatch = loc.area?.toLowerCase().includes(searchTerm);
      const lockerNumberMatch = loc.lockerNumber?.toLowerCase().includes(searchTerm);
      const descriptionMatch = loc.description?.toLowerCase().includes(searchTerm);
      
      
      if (nameMatch && !seen.has(loc.name)) {
        suggestions.push({
          id: loc.id,
          text: loc.name,
          type: 'name',
          location: loc
        });
        seen.add(loc.name);
      }
      
      if (marathiNameMatch && !seen.has(loc.marathiName)) {
        suggestions.push({
          id: `${loc.id}_marathi`,
          text: loc.marathiName,
          type: 'marathi_name',
          location: loc
        });
        seen.add(loc.marathiName);
      }
      
      if (cityMatch && !seen.has(loc.city)) {
        suggestions.push({
          id: `${loc.id}_city`,
          text: `${loc.city} (City)`,
          type: 'city',
          location: loc
        });
        seen.add(loc.city);
      }
      
      if (areaMatch && !seen.has(loc.area)) {
        suggestions.push({
          id: `${loc.id}_area`,
          text: `${loc.area} (Area)`,
          type: 'area',
          location: loc
        });
        seen.add(loc.area);
      }
      
      if (lockerNumberMatch && !seen.has(loc.lockerNumber)) {
        suggestions.push({
          id: `${loc.id}_locker`,
          text: `Locker #${loc.lockerNumber}`,
          type: 'locker_number',
          location: loc
        });
        seen.add(loc.lockerNumber);
      }
    });
    
    // Add location-based suggestions if geolocation is available
    if (currentLocation && suggestions.length === 0) {
      suggestions.push({
        id: 'current_location',
        text: 'Use my current location',
        type: 'current_location',
        location: null
      });
    }
    
    return suggestions.slice(0, 8);
  };

  // Handle search input change with suggestions
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    
    if (value.trim()) {
      const suggestions = generateSearchSuggestions(value);
      setSearchSuggestions(suggestions);
      setShowSuggestions(true);
      setHighlightedIndex(-1);
    } else {
      setShowSuggestions(false);
      setSearchSuggestions([]);
    }
  };

  // Handle suggestion selection
  const handleSuggestionClick = (suggestion) => {
    if (suggestion.type === 'current_location') {
      getCurrentLocation();
    } else if (suggestion.location) {
      setSearchQuery(suggestion.text);
      setMapCenter(suggestion.location.position);
      setZoom(16);
      setSelectedLocation(suggestion.location);
      setShowInfoPanel(true);
      const filtered = validData.filter(loc => 
        loc.name === suggestion.location.name || 
        loc.city === suggestion.location.city ||
        loc.id === suggestion.location.id
      );
      setFilteredLocations(filtered);
    }
    
    setShowSuggestions(false);
    setSearchSuggestions([]);
  };

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (!showSuggestions) return;
    
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setHighlightedIndex(prev => 
          prev < searchSuggestions.length - 1 ? prev + 1 : prev
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setHighlightedIndex(prev => prev > 0 ? prev - 1 : -1);
        break;
      case 'Enter':
        e.preventDefault();
        if (highlightedIndex >= 0 && searchSuggestions[highlightedIndex]) {
          handleSuggestionClick(searchSuggestions[highlightedIndex]);
        }
        break;
      case 'Escape':
        setShowSuggestions(false);
        break;
    }
  };

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchInputRef.current && !searchInputRef.current.contains(event.target) &&
          suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Process data when component mounts or when passedData changes
  // useEffect(() => {
  //   console.log("Processing data...");
    
  //   let processedData;
  //   if (passedData && passedData.length > 0) {
  //     processedData = transformAPIData(passedData);
  //     console.log("Using API data (transformed):", processedData);
  //   } else {
  //     // No default data - set empty array
  //     processedData = [];
  //     console.log("No lockers available");
  //   }
    
  //   const valid = processedData.filter(item => 
  //     item && 
  //     item.position && 
  //     typeof item.position.lat === 'number' && 
  //     typeof item.position.lng === 'number' &&
  //     !isNaN(item.position.lat) && 
  //     !isNaN(item.position.lng)
  //   );
    
  //   console.log("Valid data:", valid);
  //   setValidData(valid);
  //   setFilteredLocations(valid);
    
  //   if (valid.length > 0 && !selectedLocation) {
  //     setSelectedLocation(valid[0]);
  //   }
    
  //   setDataLoaded(true);
  // }, [passedData, timestamp]);

  
  // Cache data when received
  useEffect(() => {
    if (passedData && passedData.length > 0) {
      // Store in localStorage
      localStorage.setItem('cached_locker_data', JSON.stringify({
        data: passedData,
        timestamp: Date.now(),
        center: center
      }));
      setCachedData(passedData);
    } else if (!passedData && !cachedData) {
      // Try to restore from localStorage
      const cached = localStorage.getItem('cached_locker_data');
      if (cached) {
        const parsed = JSON.parse(cached);
        // Check if cache is not too old (e.g., 30 minutes)
        if (Date.now() - parsed.timestamp < 30 * 60 * 1000) {
          console.log("Restoring from cache:", parsed.data);
          setCachedData(parsed.data);
          if (parsed.center && !center) {
            setMapCenter(parsed.center);
            setCurrentLocation(parsed.center);
          }
        }
      }
    }
  }, [passedData]);

  // Process data when component mounts or when passedData changes
  useEffect(() => {
    console.log("Processing data...");
    
    let processedData;
    const dataToUse = passedData || cachedData;
    
    if (dataToUse && dataToUse.length > 0) {
      processedData = transformAPIData(dataToUse);
      console.log("Using API data (transformed):", processedData);
    } else {
      processedData = [];
      console.log("No lockers available");
    }
    
    const valid = processedData.filter(item => 
      item && 
      item.position && 
      typeof item.position.lat === 'number' && 
      typeof item.position.lng === 'number' &&
      !isNaN(item.position.lat) && 
      !isNaN(item.position.lng)
    );
    
    console.log("Valid data:", valid);
    setValidData(valid);
    setFilteredLocations(valid);
    
    if (valid.length > 0 && !selectedLocation) {
      setSelectedLocation(valid[0]);
    }
    
    setDataLoaded(true);
  }, [passedData, cachedData, timestamp]);

  // Update map center when center changes
  useEffect(() => {
    if (center) {
      setMapCenter(center);
      setCurrentLocation(center);
    }
  }, [center]);

  // Update distances when current location changes
  useEffect(() => {
    if (currentLocation && validData.length > 0) {
      console.log('Current location changed, updating distances');
      
      const updatedLocations = validData.map(loc => ({
        ...loc,
        distance: calculateDistanceMap(currentLocation, loc.position)
      }));
      
      const sortedLocations = sortByDistance(updatedLocations, currentLocation);
      
      console.log("Updated locations with distances:", sortedLocations);
      
      setFilteredLocations([...sortedLocations]);
      setValidData([...sortedLocations]);
      
      if (selectedLocation) {
        const updatedSelected = sortedLocations.find(l => l.id === selectedLocation.id);
        if (updatedSelected) {
          setSelectedLocation(updatedSelected);
        }
      }
    }
  }, [currentLocation?.lat, currentLocation?.lng, validData.length]);

  // Filter locations based on search
  useEffect(() => {
    if (!validData.length) return;
    
    if (searchQuery.trim() === '') {
      setFilteredLocations(validData);
    } else {
      const filtered = validData.filter(loc => 
        loc.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (loc.marathiName && loc.marathiName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        loc.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        loc.lockerNumber?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        loc.city?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredLocations(filtered);
    }
  }, [searchQuery, validData]);

  // Scroll to selected location in slider
  useEffect(() => {
    if (selectedLocation && sliderRef.current && isSliderVisible) {
      const index = filteredLocations.findIndex(l => l.id === selectedLocation.id);
      if (index !== -1) {
        const cardWidth = 296;
        sliderRef.current.scrollTo({
          left: index * cardWidth,
          behavior: 'smooth'
        });
      }
    }
  }, [selectedLocation, filteredLocations, isSliderVisible]);

  const getCurrentLocation = () => {
    setIsLocating(true);
    setLocationError(null);
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          console.log('Got user location:', userLocation);
          setCurrentLocation(userLocation);
          setMapCenter(userLocation);
          setZoom(16);
          setIsLocating(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          setLocationError('Unable to get your location');
          setIsLocating(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      );
    } else {
      setLocationError('Geolocation not supported');
      setIsLocating(false);
    }
  };

  const mapStyles = [
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi.business", stylers: [{ visibility: "off" }] },
    { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] }
  ];

  const mapOptions = {
    mapTypeId: 'roadmap',
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: true,
    zoomControlOptions: { position: 9 },
    gestureHandling: 'greedy',
    disableDefaultUI: true,
    styles: mapStyles,
  };

  const handleMapMarkerClick = (location) => {
    if (!location || !location.position) return;
    setSelectedLocation(location);
    setMapCenter(location.position);
    setZoom(17);
    setShowInfoPanel(true);
    setIsSliderVisible(true);
    setSliderHeight(35);
  };

  const getSettingsValidateAndRedirectUser = async (lockerBankId, location) => {
    try {
      const response = await getTenantAndAssignmentSettings(lockerBankId);
      console.log("getTenantAndAssignmentSettings is :", response);
      if (!response || response.status !== SUCCESS) {
        console.error("Invalid response from API");
        return;
      }

      applyBackendLanguageConfig(response);
      const assignments = response?.data?.locker_assignments || [];

      console.log("status:", response.status);
      console.log("assignments:", assignments.length);
      
      if (assignments.length > 1) {
        setIsLoading(false);
        history.push({
          pathname: "/assignments",
          state: {
            tenantAndAssignmentSettings: response.data
          }
        });
        return;
      }

      if (assignments.length === 1) {
        const isAssignmentProperlyConfigured = await checkIfAssignmentIsProperlyConfigured(response.data);
        if (isAssignmentProperlyConfigured === true) {
          setIsLoading(false);
          history.push({
            pathname: "/locker-details",
            state: {
              lockerDetails: location
            }
          });
        } else {
          setIsLoading(false);
          console.error("Assignment not properly configured:", isAssignmentProperlyConfigured);
        }
        return;
      }

      console.error("No locker assignments found");
    } catch (error) {
      setIsLoading(false);
      console.error("Error while getting settings and validation:", error);
    }
  };

  const handleSliderItemClick = async (location) => {
    setIsLoading(true);
    SetLoadingMessage("please wait");
    console.log("selected locker is:", location);

    if (location?.code) {
      try {
        const responseJson = await getDomainAndLockerBankIdFromShortCode(location.code);
        if (responseJson.status === SUCCESS) {
          const lockerBankId = responseJson?.data?.locker_bank_id || null;
          const domain = extractDomain(responseJson?.data?.domain);
          const domainAndLockerBankInfoObject = {
            domain,
            lockerBankId
          };
          setDomainAndLockerBankIdInLocalStorage(domainAndLockerBankInfoObject);
          if (lockerBankId) {
            await getSettingsValidateAndRedirectUser(lockerBankId, location);
          } else {
            setIsLoading(false);
            console.error("locker bank id is not there please contact to admin");
          }
        }
      } catch (error) {
        setIsLoading(false);
        console.error("HomePage.js - handleSliderItemClick", error);
      }
    } else {
      setIsLoading(false);
      console.error("not able to set the assignment details please due to locker code");
    }
  };

  const scrollSlider = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = 296;
      const newScrollLeft = sliderRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
      sliderRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    setDragStartY(e.touches ? e.touches[0].clientY : e.clientY);
    setIsDragging(true);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    
    e.preventDefault();
    const currentY = e.touches ? e.touches[0].clientY : e.clientY;
    const deltaY = currentY - dragStartY;
    
    if (isSliderVisible) {
      const newHeight = Math.max(10, Math.min(35, sliderHeight - (deltaY / 10)));
      setSliderHeight(newHeight);
      
      if (newHeight < 12) {
        setIsSliderVisible(false);
      }
    } else {
      if (deltaY < -20) {
        setIsSliderVisible(true);
        setSliderHeight(35);
      }
    }
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    
    if (isSliderVisible && sliderHeight < 12) {
      setIsSliderVisible(false);
    }
    
    if (isSliderVisible) {
      if (sliderHeight < 20) {
        setSliderHeight(15);
      } else if (sliderHeight > 35) {
        setSliderHeight(35);
      }
    }
  };

  const LockerMarker = ({ location, onClick, isSelected }) => {
    if (!location || !location.position) return null;
    
    const getSizeClass = () => {
      if (zoom >= 16) return 'xl';
      if (zoom >= 14) return 'lg';
      if (zoom >= 12) return 'md';
      if (zoom >= 10) return 'sm';
      return 'xs';
    };

    const sizeClass = getSizeClass();
    
    const getColorClass = (type) => {
      const colorMap = {
        'city': 'city',
        'industrial': 'industrial',
        'commercial': 'commercial',
        'municipal': 'municipal',
        'temple': 'temple',
        'tourist': 'tourist',
        'landmark': 'landmark',
        'area': 'area',
        'society': 'society',
        'store': 'store',
        'colony': 'colony',
        'market': 'market',
        'park': 'park'
      };
      return colorMap[type?.toLowerCase()] || 'default';
    };

    return (
      <OverlayView
        position={location.position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      >
        <div 
          className={`marker-container ${isSelected ? 'selected' : ''}`}
          onClick={() => onClick(location)}
        >
          <div className={`marker-image-wrapper size-${sizeClass}`}>
            <img 
              src={LockerIcon}
              alt={location.name}
              className="marker-image"
            />
            <div className={`marker-badge badge-${sizeClass} marker-badge-${getColorClass(location.type)}`}>
              {location.lockerNumber?.split('-')[1] || location.id}
            </div>
          </div>
          <div className={`marker-label label-${sizeClass}`}>
            {location.distance || '0'}km
          </div>
        </div>
      </OverlayView>
    );
  };

  const CurrentLocationMarker = () => {
    const [mapsLoaded, setMapsLoaded] = useState(false);

    useEffect(() => {
      const checkMapsLoaded = () => {
        if (window.google && window.google.maps) {
          setMapsLoaded(true);
        }
      };

      checkMapsLoaded();
      const timer = setTimeout(checkMapsLoaded, 1000);
      return () => clearTimeout(timer);
    }, []);

    if (!currentLocation || !currentLocation.lat || !currentLocation.lng || !mapsLoaded) {
      return null;
    }

    return (
      <Marker
        position={currentLocation}
        icon={{
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: "#4285F4",
          fillOpacity: 1,
          strokeColor: "white",
          strokeWeight: 3,
        }}
        title="You are here"
      />
    );
  };


  return (
    <>
    <div 
      className="map-mobile-container"
      onTouchMove={handleDragMove}
      onTouchEnd={handleDragEnd}
      onMouseMove={isDragging ? handleDragMove : null}
      onMouseUp={handleDragEnd}
      onMouseLeave={handleDragEnd}
      ref={containerRef}
    >
      <div className="map-wrapper">
        {/* SEARCH SECTION */}
        <SearchSection
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          onSearchClear={() => {
            setFilteredLocations(validData);
          }}
          onSuggestionSelect={(suggestion) => {
            if (suggestion.type === 'current_location') {
              getCurrentLocation();
            } else if (suggestion.location) {
              setMapCenter(suggestion.location.position);
              setZoom(16);
              setSelectedLocation(suggestion.location);
              setShowInfoPanel(true);
            }
          }}
          validData={validData}
          currentLocation={currentLocation}
          filteredLocations={filteredLocations}
          setFilteredLocations={setFilteredLocations}
        />
        
        {locationError && (
          <div className="location-error">
            {locationError}
          </div>
        )}
        
        <LoadScript 
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
          loadingElement={
            <div className="loading-container">
              <div className="loading-content">
                <div className="loading-text">Loading Map...</div>
              </div>
            </div>
          }
        >
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={mapCenter}
            zoom={zoom}
            options={mapOptions}
            onClick={() => setShowInfoPanel(false)}
            onLoad={(map) => {
              mapRef.current = map;
            }}
            onZoomChanged={() => {
              if (mapRef.current) {
                setZoom(mapRef.current.getZoom());
              }
            }}
          >
            <CurrentLocationMarker />
            
            {filteredLocations.map((location) => (
              <LockerMarker
                key={location.id}
                location={location}
                onClick={handleMapMarkerClick}
                isSelected={selectedLocation?.id === location.id}
              />
            ))}
          </GoogleMap>
        </LoadScript>
        
        {/* Bottom Slider Section */}
        <div 
          className={`bottom-slider-container ${!isSliderVisible ? 'hidden' : ''}`}
        >
          <div 
            className="drag-handle"
            onTouchStart={handleDragStart}
            onMouseDown={handleDragStart}
          >
            <div className="drag-handle-bar"></div>
            <div className="drag-instruction">
              {isSliderVisible 
                ? sliderHeight >= 35
                  ? '↓ Drag down to hide' 
                  : '↓ Drag down to hide | ↑ Drag up to expand'
                : '↑ Drag up to show lockers'}
            </div>
          </div>
          
          <LocationSlider
            ref={sliderRef}
            currentLocation={currentLocation}
            filteredLocations={filteredLocations}
            selectedLocation={selectedLocation}
            onLocationClick={handleSliderItemClick}
            onScrollLeft={() => scrollSlider('left')}
            onScrollRight={() => scrollSlider('right')}
            isVisible={isSliderVisible}
          />
        </div>
        
        {isLoading ? 
          <CircularProgressLoader message={loadingMessage} /> : ''}
      </div>
    </div>
    </>
  );
};



export default LockerMapMobile;